import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { CIBLES, habillage } from '@qanbio/design';

import { AppPartage } from './app';
import './styles.css';

/**
 * L'habillage est injecté, pas recopié — mêmes principes que `apps/console`.
 *
 * Surface `passager` : cette page est consultée par un proche, sur un
 * téléphone, dans les mêmes conditions d'usage — clair, tactile, quelques
 * secondes d'attention. Les cibles suivent `CIBLES`, pas `CIBLES_CONSOLE` :
 * cette page n'a rien d'un poste de travail.
 */
const { couleurs, mesures, ombre } = habillage('passager');
const racine = document.documentElement.style;
racine.setProperty('--ground', couleurs.fond);
racine.setProperty('--panel', couleurs.surface);
racine.setProperty('--panel-2', couleurs.surfaceDouce);
racine.setProperty('--ink', couleurs.texte);
racine.setProperty('--ink-2', couleurs.texteSecondaire);
racine.setProperty('--ink-3', couleurs.texteTertiaire);
racine.setProperty('--line', couleurs.ligne);
racine.setProperty('--line-strong', couleurs.ligneForte);
racine.setProperty('--accent', couleurs.accent);
racine.setProperty('--accent-ink', couleurs.accentSombre);
racine.setProperty('--accent-soft', couleurs.accentDouce);
racine.setProperty('--on-accent', couleurs.surAccent);
racine.setProperty('--shadow', ombre);
racine.setProperty('--radius-sm', `${String(mesures.rayonPetit)}px`);
racine.setProperty('--radius', `${String(mesures.rayon)}px`);
racine.setProperty('--radius-md', `${String(mesures.rayonMoyen)}px`);
racine.setProperty('--radius-lg', `${String(mesures.rayonLarge)}px`);
racine.setProperty('--cible', `${String(CIBLES.minimum)}px`);
racine.setProperty('--cible-principale', `${String(CIBLES.principale)}px`);
racine.setProperty('--ecart', `${String(CIBLES.ecart)}px`);

const conteneur = document.getElementById('root');
if (conteneur === null) throw new Error('Point de montage de la page de partage absent');

createRoot(conteneur).render(
  <StrictMode>
    <AppPartage />
  </StrictMode>,
);
